import { Dialog } from '@headlessui/react';
import React from 'react';

export const DialogTitle: React.FC<{
  children: React.ReactNode;
  'data-testid'?: string;
  className?: string;
}> = ({ children, 'data-testid': dataTestId, className }) => (
  <Dialog.Title
    className={`mb-1 text-black text-[17px] font-medium leading-[25px] ${
      className || ''
    }`}
    data-testid={dataTestId}
  >
    {children}
  </Dialog.Title>
);

export const DialogDescription: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <Dialog.Description
    className={`font-medium leading-6 text-[#72757a] m-0 text-center ${
      className || ''
    }`}
  >
    {children}
  </Dialog.Description>
);

export const DialogPanel: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <Dialog.Panel
    className={`bg-white h-min max-w-[448px] border border-[#dddfe5] rounded-[14px] fixed inset-0 m-auto flex flex-col justify-center z-[220] ${
      className || ''
    }`}
  >
    {children}
  </Dialog.Panel>
);

export const DialogBackdrop: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => <div className="bg-[#32343980] fixed inset-0 z-[210]">{children}</div>;

export const StyledText: React.FC<{
  children: React.ReactNode;
  className?: string;
  title?: string;
}> = ({ children, className }) => (
  <span className={`overflow-hidden text-ellipsis ${className || ''}`}>
    {children}
  </span>
);

export const LineClampText: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <span className="overflow-hidden text-ellipsis line-clamp-1">{children}</span>
);

export const ListItem: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <li className="list-none">{children}</li>;

export const UnorderedListContainer: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <ul className="flex-1 overflow-y-scroll w-full m-0 px-6 [&>li+li]:mt-6">
    {children}
  </ul>
);

export const Thumbnail: React.FC<{
  src: string;
  alt: string;
  className?: string;
  draggable?: boolean;
}> = ({ src, alt, className, draggable = false }) => (
  <img
    src={src}
    alt={alt}
    className={`rounded-[10px] h-9 w-14 min-w-14 bg-[#d9d9d9] ${
      className || ''
    }`}
    draggable={draggable}
  />
);
